import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'
import RefreshLink from './RefreshLink'
import IconLink from 'components/Shared/IconLink/Index'

import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_INFO,
} from 'constants/notification'

const StyledNotification = styled.div`
  min-height: 40px;
  width: 100%;
  position: absolute;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: ${props => props.colorText};
  cursor: ${props => props.clickable ? 'pointer' : 'auto'};
  background-color: ${props => props.colorBg};
  border: 1px solid ${props => props.color}CC;
  border-left: 4px solid ${props => props.color};
`

const Body = styled.div`
  display: flex;
  align-items: center;
`

const StyledMessage = styled.div`
  margin-left: 20px;
  font-size: 14px;
`

const StyledCloseIcon = styled(IconLink)`
  padding: 6px 18px 6px 6px;
`

const ActionButtons = styled.div`
  display: flex;
  margin: 0 10px;
`

const ActionButton = styled(IconLink)`
  padding: 3px 8px;
  color: ${colors.secondary40};
`

const colorsMap = {
  [NOTIFICATION_TYPE_ERROR]: {
    color: colors.alert,
    colorBg: colors.alertBg,
    colorText: colors.alertText,
  },
  [NOTIFICATION_TYPE_SUCCESS]: {
    color: colors.success,
    colorBg: colors.successBg,
    colorText: colors.successText,
  },
  [NOTIFICATION_TYPE_WARNING]: {
    color: colors.warning,
    colorBg: colors.warningBg,
    colorText: colors.warningText,
  },
  [NOTIFICATION_TYPE_INFO]: {
    color: colors.info,
    colorBg: colors.infoBg,
    colorText: colors.infoText,
  },
}

const NotificationBar = ({
  notificationId,
  text,
  type,
  hideRefreshLink,
  actionButtons,
  actionButtonClick,
  clearNotification,
  dataTest,
}) => {
  if (!text) {
    return null
  }

  const { color, colorBg, colorText } = colorsMap[type]

  return (
    <StyledNotification
      color={color}
      colorBg={colorBg}
      colorText={colorText}
      onClick={() => !actionButtons && clearNotification?.()}
      clickable={!actionButtons}
      data-test={dataTest}
    >
      <Body>
        <StyledMessage>{text}</StyledMessage>
        {actionButtons && (
          <ActionButtons>
            {actionButtons.map(btn => {
              return (
                <ActionButton
                  key={btn.id}
                  iconName={btn.icon}
                  text={btn.text}
                  hoverColorGray
                  onClick={() => { actionButtonClick?.({ notificationId: notificationId, buttonId: btn.id }) }}
                />
              )
            })}
          </ActionButtons>
        )}
      </Body>
      {!hideRefreshLink && <RefreshLink type={type} />}
      <StyledCloseIcon
        iconName='icon-close-notification'
        onClick={() => !!actionButtons && clearNotification?.()}
      />
    </StyledNotification>
  )
}

NotificationBar.propTypes = {
  notificationId: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string.isRequired,
  hideRefreshLink: PropTypes.bool,
  actionButtons: PropTypes.array,
  actionButtonClick: PropTypes.func,
  clearNotification: PropTypes.func,
  dataTest: PropTypes.string,
}

export default NotificationBar
